import { Stack } from "@mui/material";
import { styled } from "@mui/material/styles";

export const ContactInfoStack = styled(Stack)(({ theme }) => ({
  gap: "2px",
  width: "fit-content",
  "span, p": { lineHeight: 1 },
}));
